import SlidesBoForm from './components/pages/backoffice/form/slides-bo-form';
customElements.define('slides-bo-form', SlidesBoForm,{extends: 'div'});